/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-14 09:57:36
 * @LastEditors: linxi
 * @LastEditTime: 2024-03-15 16:48:34
 */
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  Space,
  notification,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { recentTimeParams } from '../../services/recentTime'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  RecentTimesRealThreeMonths,
} from '../../compnents/form/DateSelect'
import {
  pageDurgsystem,
  selectDurgsystemData,
} from '../durgsystem/durgsystemSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
  getRecentTimeOut,
  getRecentTimePrint,
  setCurrent,
} from './recentTimeSlice'
import { PrintOutlined } from '../../compnents/icons/Icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { DateTimeFormat } from '../../models/datetime'
import moment from 'moment'
import {
  getPrinters,
  initializePrintService,
  printTemplate,
  selectPrintServiceState,
} from '../print/printSlice'
import { LoadingState } from '../../models/common'
import styles from './recentTime.module.css'
const { Option } = Select

export const RecentTimeQuery = (props: {
  loading?: any
  onValueChange: (queries: recentTimeParams) => void
  exportExcel: () => void
  outLoading?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()
  const initialized = useSelector(selectPrintServiceState)

  const durgData = useSelector(selectDurgsystemData)

  const [printLoading, setPrintLoading] = useState(false)
  const endTime = moment().add(180, 'days').endOf('days').format(DateTimeFormat)
  const dateColorList = [
    {name: '已失效', color: '#9564ad'},
    {name: '近1个月', color: '#FF5D5D'},
    {name: '近3个月', color: '#FA8714'},
    {name: '近6个月', color: '#0787F4'},
    {name: '大于6个月', color: '#333333'},
  ]
  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    form.setFieldsValue({
      [DateRangeFieldName]: DateRangeType.HalfAYear,
    })
  }, [])
  useEffect(() => {
    if (initialized === LoadingState.Idle) {
      dispatch(initializePrintService())
        .then(unwrapResult)
        .catch(() => {
          // do nothing.
        })
    }
    if (initialized === LoadingState.Finished) {
      dispatch(getPrinters())
    }
  }, [dispatch, initialized])

  return (
    <Form
      form={form}
      name='control-hooks'
      onFinish={(vs) => {
        props.onValueChange({
          ...form.getFieldsValue(),
          deadlineStart: form.getFieldsValue().registrationTimeHead
            ? form.getFieldsValue().registrationTimeHead
            : moment().format(DateTimeFormat),
          deadlineEnd: form.getFieldsValue().registrationTimeTail
            ? form.getFieldsValue().registrationTimeTail
            : endTime,
          registrationTimeHead: undefined,
          registrationTimeTail: undefined,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='keyword' noStyle>
            <Input
              size='middle'
              placeholder='请输入物资名称/批次号'
              onChange={form.submit}
              allowClear
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='storehouseId' noStyle>
            <Select
              placeholder='库房列表'
              allowClear
              showSearch
              // suffixIcon={<CaretDownFilled />}
              onChange={form.submit}
              optionFilterProp='children'
            >
              {durgData.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='materialsCategory' noStyle>
            <Select
              placeholder='物资类别'
              onChange={form.submit}
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>药品</Option>
              <Option value={1}>材料</Option>
              <Option value={2}>器械</Option>
              <Option value={3}>其他</Option>
            </Select>
          </Form.Item>
          <DateSelect
            style={{ width: '120px' }}
            placeholder='有效期至'
            allowClear={false}
            labelPrefix=''
            options={RecentTimesRealThreeMonths}
            namePrefix='registrationTime'
            onChange={form.submit}
          />
          <Button type='primary' onClick={form.submit} loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space>
          <Col flex={1} style={{ display: 'flex', justifyContent: 'end' }}>
          <div className={styles.flexbox}>
            {
              dateColorList?.map(v => {
                return (
                  <div className={styles.flexbox} key={v.name}>
                    <span className={styles.iconItem} style={{ background: v.color }}></span>
                    <span>{v.name}</span>
                  </div>
                )
              })
            }
          </div>
        </Col>
        </Space>
      </Row>
    </Form>
  )
}
